import { PEERS_LIMIT, REGIONS } from '@/pages/CompanyReport/constants';
import { useQuery } from '@tanstack/react-query';
import {
  getHistogramQueryKey,
  getPeersQueryKey,
  queryHistogramFn,
  queryPeersFn,
} from '../query';
import { useValuationData } from '../selector';

const getIndustrySource = (
  industryFallbackLevel: string | undefined,
  countryName: string,
  regionName: string
) => {
  if (industryFallbackLevel === 'country') return countryName;
  if (industryFallbackLevel === 'region') return regionName;
  return 'Global';
};

export function useIndustrySource() {
  const selected = useValuationData();

  const { data, status } = useQuery({
    queryKey: getHistogramQueryKey(selected.canonicalUrl),
    queryFn: queryHistogramFn,
    staleTime: Infinity,
    enabled: Boolean(selected.canonicalUrl),
  });

  const { data: companyData } = useQuery({
    queryKey: getPeersQueryKey(selected.canonicalUrl, PEERS_LIMIT),
    queryFn: queryPeersFn,
    enabled: Boolean(selected.canonicalUrl),
  });

  const { countryISO: countryName, industrySecondaryName: industryName } =
    selected;
  const industryFallbackLevel = data?.Company.industryHistogram.level;
  const regionId = companyData?.Company.country?.region.id;
  const regionName = regionId ? REGIONS[regionId]?.adjective : '';

  const industrySource = getIndustrySource(
    industryFallbackLevel,
    countryName,
    regionName
  );

  return {
    industrySource: status === 'success' ? industrySource : undefined,
    industryName: typeof industryName === 'string' ? industryName : undefined,
  };
}
